import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { Spinner } from "react-bootstrap";
import { useAuth } from "../../components/AuthContext/AuthContext";
import LoggedInLayout from "../../stories/LoggedInScreens/LoggedInLayout";
import VHConfirmationPopup from "../../stories/Modals/VHConfirmationPopup";
import logo from "../../assets/images/boots-myhealthchecked-logo.svg";
import img from "../../assets/images/notification.svg";
import { links } from "../../stories/Forms/fields";
import "../../assets/scss/_consultation-cancelled.scss";
import { formatCost } from "../../utils/utils";
import useApis from "../../services/useAPI";

function ConsultationCancelled() {
  const auth = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const appointmentId = location.state?.id?.id ?? location.state?.id;
  const postUrl = `/api/phlebotomists-portal/register-appointment/${appointmentId}/`;
  const { callApi, resultGet, isLoading } = useApis();

  useEffect(() => {
    auth?.resetAllowedStage();
  }, []);

  useEffect(() => {
    if (location.state?.isHealthcare && appointmentId) {
      callApi(null, postUrl, "GET");
    }
  }, [location.state?.isHealthcare, appointmentId]);

  useEffect(() => {
    if (!location.state?.rejectionMessage) {
      navigate("/patient-record", { replace: true });
    }
  }, [location.state?.rejectionMessage, navigate]);

  const repeatedTest =
    resultGet?.data?.repeated_test ?? resultGet?.repeated_test;

  const showPaymentNotRequired =
    auth?.featureFlag &&
    location.state?.isHealthcare === true &&
    (String(repeatedTest || "").includes("(paid)") ||
      sessionStorage.getItem("kitRejectedId") === String(location.state?.id));

  const isHealthcareLoading =
    Boolean(location.state?.isHealthcare && appointmentId) &&
    (isLoading || !resultGet);

  if (isHealthcareLoading) {
    return (
      <div className="text-center py-4">
        <Spinner animation="border" className="my-custom-spinner" />
      </div>
    );
  }

  return (
    <LoggedInLayout
      buttonLabel="Logout"
      img={img}
      isActivation={false}
      links={links}
      logo={logo}
      pageTitle={auth.title}
      userInitials={auth.userInitials}
      vitalityLayout={auth?.featureFlag}
      isVhlogin={auth?.featureFlag}
    >
      {location.state?.isSuccess ? (
        <div className="consultation-cancelled-page consultation-success-page">
          <VHConfirmationPopup
            title="Service completed successfully"
            message={
              location.state?.serviceType === "private-service" ||
              location.state?.service === "private-service" ? (
                <>
                  The patient will receive an email with a link to view their
                  results on their online account.{" "}
                </>
              ) : location.state?.isClinical === true ? (
                ""
              ) : showPaymentNotRequired ? (
                ""
              ) : location.state?.isHealthcare === true ? (
                <span>
                  Payment to be collected from the patient at the till.
                  <br />
                  Patients may use their Advantage Card to collect points at the
                  till during the <br />
                  transaction.
                  <br />
                  <br />
                  The patient will receive an email notification when their
                  sample begins
                  <br /> processing at the laboratory, and when their test
                  results are available on their <br />
                  account.
                </span>
              ) : (
                <span>
                  Payment to be collected from the patient at the till -{" "}
                  <b className="fs-18">
                    {formatCost(
                      location.state?.serviceType ?? location.state?.service,
                    )}
                  </b>
                  <br />
                  Patients may use their Advantage Card to collect points at the
                  till during the transaction.
                  <br />
                  <br />
                  The patient will receive an email with a link to view their
                  test results online.
                </span>
              )
            }
            primaryLabel={
              localStorage.getItem("selectedService") === "healthCare"
                ? "Back to patient search"
                : "Back to participant search"
            }
            primaryHref="/patient-record"
          >
            {showPaymentNotRequired && (
              <>
                <div className="repeat-test-alert">
                  <VHConfirmationPopup
                    showIcon={false}
                    warningText="Repeat test. Payment not required."
                  />
                </div>
                <p className="vh-confirmation-popup__message repeat-test-message">
                  The patient will receive an email notification when their
                  sample begins
                  <br /> processing at the laboratory, and when their test
                  results are available on their <br />
                  account.
                </p>
              </>
            )}
          </VHConfirmationPopup>
        </div>
      ) : (
        <div className="consultation-cancelled-page">
          <VHConfirmationPopup
            title="Service exited successfully"
            message=""
            primaryLabel="Back to patient search"
            primaryHref="/patient-record"
          />
        </div>
      )}
    </LoggedInLayout>
  );
}

export default ConsultationCancelled;
